import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Full-page backdrop with a spinner, shown while `show` is true; projected content is rendered above the spinner
 */
@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [],
  templateUrl: './loading.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input() show!: boolean;
}
